export const trans_8_1=[
  {
    id:1,
    english:'What kind of films do you like?',
    vietnamese:'Bạn thích xem thể loại phim nào?',
    user_message:''
  },
  {
    id:2,
    english:'I want to eat something',
    vietnamese:'Tôi muốn ăn thứ gì đó',
    user_message:''
  },
  {
    id:3,
    english:'Where is the kithen?',
    vietnamese:'Bé ở đâu?',
    user_message:''
  },
  {
    id:4,
    english:'How do you make pizza?',
    vietnamese:'Làm bánh pizza như thế nào?',
    user_message:''
  }, 

]

export const trans_8_2=[
  {
    id:1,
    english:'What would you like for lunch? I want to eat a plate of salad',
    vietnamese:'Bạn muốn ăn gì vào bữa trưa? Tôi muốn ăn một đĩa salad',
    user_message:''
  },
  {
    id:2,
    english:'Is this beefsteak delicious? This dish is delicious',
    vietnamese:'Món bò bít tết này có ngon không? Món này rất ngon',
    user_message:''
  },
  {
    id:3,
    english:'Pho is traditional food of Viet Nam',
    vietnamese:'Phở là món ăn truyền thống của  Việt Nam',
    user_message:''
  },
  {
    id:4,
    english:'I love Vietnamese cuisine',
    vietnamese:'Tôi thích các món ăn ẩm thực của người Việt Nam',
    user_message:''
  },  

]